module.exports = __webpack_public_path__ + "videos/stroke-dark.18e1509.mp4";